export const thunkResponseCheckerSdk = async (
  fn: () => Promise<any>,
  rejectWithValue: (value: unknown) => any,
  isData = true
) => {
  const response = await fn();

  if (response.success) {
    if (isData && response.data) {
      return response.data;
    } else {
      return;
    }
  }

  return rejectWithValue(response.errors);
};
